import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (
                <div style={{
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f8f9fa'
                }}>
                    <div style={{
                        padding: '2rem',
                        textAlign: 'center',
                        backgroundColor: 'white',
                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        maxWidth: '600px',
                        width: '90%'
                    }}>
                        <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>Something went wrong.</h2>
                        <p style={{ color: '#6c757d', marginBottom: '1.5rem' }}>An unexpected error occurred. Our team has been notified.</p>

                        <details style={{ whiteSpace: 'pre-wrap', marginTop: '1rem', textAlign: 'left', backgroundColor: '#f8f9fa', padding: '1rem', borderRadius: '4px', fontSize: '0.85rem', color: '#212529', overflowX: 'auto' }}>
                            <summary style={{ cursor: 'pointer', marginBottom: '0.5rem' }}>View Error Details</summary>
                            {this.state.error && this.state.error.toString()}
                            <br />
                            {this.state.errorInfo && this.state.errorInfo.componentStack}
                        </details>

                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                marginTop: '1.5rem',
                                padding: '0.75rem 1.5rem',
                                background: '#3182ce',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                fontWeight: '500'
                            }}
                        >
                            Reload Page
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
